import validator from "validator";

export const validationRules = {
  // validaciones globales
  validateCampo: [(val) => !!val || "Campo requerido"],
  validateCampoList: [(val) => !!val || "Seleccione un campo de la lista"],
  validateCampoNulos: [(val) => val !== null || "Campo requerido"],
  validateEmptyArray: [(val) => (!!val && !!val.length) || "Seleccione un campo de la lista"],
  validateOnlynmbers: [
    (val) => !!val || "numero requerido",
    (val) => validator.isNumeric(val) || "solo se permiten numeros",
    (val) => Number(val) >= 0 || "Debe ingresar un numero positivo",
  ],

  validateCuentas: [
    (val) => val !== null && !!val || "Lo ingresado es invalido",
    // (val) => validator.isNumeric(val) || "solo se permiten numeros",
    (val) => val === null || val.length > 4 || "Lo ingresado es muy corto",
    (val) => val === null || val.length < 20 || "Lo ingresado es muy largo"
  ],

  validatePassword: [
    (val) => !!val || "Ingrese una contraseña",
    (val) => (typeof val === 'string' && val.length > 6) || "La contraseña es muy corta",
    (val) => (typeof val === 'string' && val.length < 20) || "La contraseña es muy larga",
  ],

  validateCorreo: [
    (val) => (val && validator.isEmail(val)) || "Correo electrónico inválido",
  ],

  // validateDni: [
  //   (val) => val !== null && !!val || "DNI requerido",
  //   (val) => val === null || validator.isNumeric(val) || "solo se permiten numeros",
  //   (val) => val === null || val.length < 9 || "Documento invalido",
  // ],
  validateDni: [
    (val) => !!val || "DNI requerido", // Asegúrate de que el valor no es nulo ni vacío
    (val) => !val || validator.isNumeric(val) || "Solo se permiten números", // Aplica la validación numérica solo si hay un valor
    (val) => !val || (val.length === 8) || "El DNI debe tener 8 dígitos", // Asegúrate de que la longitud sea 8
  ],

  validateRuc: [
    (val) => !!val || "RUC requerido",
    (val) => !val || validator.isNumeric(val) || "solo se permiten numeros",
    (val) => !val || val.length === 11 || "RUC invalido",
  ],

  validateDocument: [
    (val) => !!val || "Documento requerido",
    (val) => !val || validator.isNumeric(val) || "solo se permiten numeros",
    (val) => !val || val.length >= 8 && val.length <= 9 || "Documento invalido",

  ],
  validatePhone: [
    (val) => val !== null && !!val || "Teléfono fijo requerido",
    (val) => val === null || validator.isNumeric(val) || "solo se permiten numeros",
    (val) => val === null || val.length < 20 || "El numero es invalido",
  ],
  validateMovilphone: [
    (val) => val !== null && !!val || "Teléfono movil requerido",
    (val) => val === null || validator.isNumeric(val) || "solo se permiten numeros",
    (val) => val === null || val.length <= 9 || "Coloque su numero de móvil",
  ],

  validateChambaphone: [
    (val) => val !== null && !!val || "Teléfono del trabajo requerido",
    (val) => val === null || validator.isNumeric(val) || "solo se permiten numeros",
    (val) => val === null || val.length <= 20 || "El numero es invalido",
  ],

  validateName: [
    (val) => val !== null && !!val || "Nombre requerido",
    (val) => val === null || val.length < 60 || "El nombre es demasiado largo",
    (val) => /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g.test(val) || "Por favor ingrese un nombre válido",
  ],

  validateInstName: [
    (val) => !!val || "Nombre requerido",
    (val) => val.length < 60 || "El nombre es demasiado largo",
  ],
  validateSeccionAbr: [
    (val) => val !== null && !!val || "Seccion requerido",
    (val) => val === null || val.length <= 2 || "2 letras como máximo",
  ],
  validateNivel: [(val) => !!val || "Seleccione un nivel"],
  validateGrado: [(val) => !!val || "Seleccione un grado"],
  validateArea: [(val) => !!val || "Seleccione el área"],
  validateCurso: [(val) => !!val || "Seleccione el curso de referencia"],
  validateSeccion: [(val) => !!val || "Seleccione una sección"],
  validatetextArea: [(val) => !!val || "Complete el campo"],
  validatefechInicio: [(val) => !!val || "Fecha de inicio requerida"],
  validatefechFin: [(val) => !!val || "Fecha de fin requerida"],


  // comunicados validators

  ValidateDestino: [(val) => !!val || "Seleccione el destino del comunicado"],

  //gestion de areas validators

  validatenameArea: [
    (val) => !!val || "Nombre de área requerido",
    (val) => val.length < 60 || "El nombre es demasiado largo",
    // (val) => /^[a-zA-Z_ ]*$/.test(val) || "Por favor ingrese un nombre valido",
  ],

  siagievalidate: [(val) => !!val || "Nombre de SIAGIE requerido"],

  //gestiond de cursos validators
  validarnameCursos: [
    (val) => !!val || "Nombre de curso requerido",
    (val) => val.length < 60 || "El nombre es demasiado largo",
    // (val) => /^[a-zA-Z_ ]*$/.test(val) || "Por favor ingrese un nombre valido",
  ],

  // gestiond de permisos de usuarios
  validarnameperfil: [
    (val) => !!val || "Nombre de perfil requerido",
    (val) => val.length < 40 || "El nombre es demasiado largo",
    (val) => /^[a-zA-Z_ ]*$/.test(val) || "Por favor ingrese un nombre valido",
  ],

  validarPerfil: [(val) => !!val || "Seleccione un perfil"],
  validartipoLicencia: [(val) => !!val || "Seleccione un tipo de licencia"],
  validarModulo: [(val) => !!val || "Seleccione un modulo"],

  // mi colegio validaciones

  validatenameColegio: [(val) => !!val || "Escriba el nombre del colegio"],
  validateDirecciondelColegio: [
    (val) => !!val || "Direccion de colegio requerida",
    (val) => val.length < 150 || "Por favor abrevie la descripcion",
  ],

  // validaciones no requeridas pero si por cantidad de caracteres

  max10: [(val) => (val || "").length <= 10 || "Máximo 10 caracteres"],
  max20: [(val) => (val || "").length <= 20 || "Máximo 20 caracteres"],
  max30: [(val) => (val || "").length <= 30 || "Máximo 30 caracteres"],
  max50: [(val) => (val || "").length <= 50 || "Máximo 50 caracteres"],
  max60: [(val) => (val || "").length <= 60 || "Máximo 60 caracteres"],
  max100: [(val) => (val || "").length <= 100 || "Máximo 100 caracteres"],
  max150: [(val) => (val || "").length <= 150 || "Máximo 150 caracteres"],


  // validaciones para minimo valor en los campos

  min4: [(v) => (v || "").length >= 4 || "Mínimo 4 caracteres"],
  min6: [(v) => (v || "").length >= 6 || "Mínimo 6 caracteres"],
  min8: [(v) => (v || "").length >= 8 || "Mínimo 8 caracteres"],
};
